var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4680FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0413 24C13.7964 24 11.895 23.2252 10.337 21.6755C8.77899 20.1258 8 18.2345 8 16.0016C8 13.7687 8.77899 11.8769 10.337 10.3262C11.895 8.77539 13.7964 8 16.0413 8C17.2949 8 18.4811 8.27727 19.6 8.83182C20.7189 9.38634 21.6495 10.1689 22.3918 11.1795V8H24V14.523H17.4433V12.9231H21.6784C21.1134 11.8933 20.3299 11.082 19.3279 10.4892C18.3258 9.89639 17.2303 9.59998 16.0413 9.59998C14.2543 9.59998 12.7354 10.2222 11.4845 11.4667C10.2337 12.7111 9.60823 14.2222 9.60823 16C9.60823 17.7778 10.2337 19.2889 11.4845 20.5333C12.7354 21.7778 14.2543 22.4 16.0413 22.4C17.4172 22.4 18.6591 22.0089 19.767 21.2267C20.875 20.4445 21.6523 19.4133 22.099 18.1333H23.7938C23.3072 19.8742 22.3488 21.2872 20.9186 22.3723C19.4883 23.4574 17.8625 24 16.0413 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshHover);
export default __webpack_public_path__ + "static/media/refresh_hover.b47f628a1639b2df2a7989f1fd3ec0ef.svg";
export { ForwardRef as ReactComponent };